import { useState, useEffect } from "react";
import axios from "axios";
import StoryDetailBanner from "./StoryDetailBanner";
import StoryAuthor from "./StoryAuthor";
import StoryText from "./StoryText";
import StoryOption from "./StoryOption";
import Advise from "../Home-Page/views/Advise";

const fetchDataCategory = async () => {
  const response = await axios.get(
    "https://api-bluerise.bluerise.com.vn/category/get-all"
  );
  console.log(response);
  if (response.status === 200) {
    return response.data;
  }
  return null;
};
const fetchDataNews = async () => {
  const response = await axios.post(
    "https://api-bluerise.bluerise.com.vn/news/get-publish",
    {
      keyword: "",
      type: 2,
      status: 2,
      pageNum: 1,
      pageSize: 10,
    }
  );
  if (response.status === 200) {
    return response.data;
  }
  return null;
};

function extractFirstImageAndText(htmlContent) {
  // Tìm thẻ <img> đầu tiên
  const imgRegex = /<img[^>]*src="([^"]*)"[^>]*>/;
  const match = imgRegex.exec(htmlContent);

  let firstImage = null;
  if (match) {
    firstImage = match[1]; // Lấy src của thẻ <img> đầu tiên
  }

  // Xóa thẻ <img> đầu tiên khỏi nội dung HTML
  const textWithoutFirstImage = htmlContent.replace(imgRegex, "");

  return { text: textWithoutFirstImage, firstImage };
}

export default function StoryDetail() {
  const [categories, setCategories] = useState([]);
  const [firstCaseStudy, setFirstCaseStudy] = useState();
  const [caseStudies, setCaseStudies] = useState([]);

  useEffect(() => {
    if (!categories || categories.length === 0) {
      fetchDataCategory().then((data) => {
        setCategories(data);
      });
    }
    fetchDataNews().then((data) => {
      if (data.length > 0) {
        setFirstCaseStudy(data[0]);
        data.splice(0, 1);
        setCaseStudies(data);
      }
    });
  }, []);
  let shortContent = extractFirstImageAndText(
    firstCaseStudy?.shortContent ?? ""
  );
  let { text, firstImage } = extractFirstImageAndText(
    firstCaseStudy?.mainContent ?? ""
  );
  console.log(caseStudies);
  return (
    <div className="pt-[71px] w-full">
      <StoryDetailBanner text={shortContent.text} />
      <StoryAuthor
        banner={firstImage}
        categories={categories}
        caseStudy={firstCaseStudy}
      />

      <StoryText className="text-white" htmlContent={text} />
      <StoryOption categories={categories} caseStudies={caseStudies} />
      <Advise />
    </div>
  );
}
